import React from "react"
import styled from "styled-components"

const VideoBlock = styled.figure`
  margin: var(--spacing-xxl) 0;
`

const ResponsiveVideoWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
`

const IFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
`

const Label = styled.figcaption`
  display: block;
  width: 100%;
  text-align: center;
  font-size: var(--font-sm);
  color: var(--color-text-inactive);
`

const BlockVideo = ({ data }) => {
  if (!data.url) {
    console.warn("No video URL fetched", data)
    return <></>
  }

  const getSrc = () => {
    if (data.url.provider === "youtube") {
      return `https://www.youtube.com/embed/${data.url.providerUid}?autoplay=${data.autoplay}&mute=${data.autoplay}`
    } else if (data.url.provider === "vimeo") {
      return `https://player.vimeo.com/video/${data.url.providerUid}`
    } else if (data.url.provider === "facebook") {
      return `https://www.facebook.com/plugins/video.php?href=${data.url.providerUid}`
    } else {
      return null
    }
  }

  const src = getSrc()
  if (!src) {
    return (
      <span title={`Unsupported video provider: ${data.url.provider}.`}></span>
    )
  }

  return (
    <VideoBlock>
      <ResponsiveVideoWrapper>
        <IFrame
          src={src}
          allow="autoplay; encrypted-media; fullscreen"
          allowFullScreen
        ></IFrame>
      </ResponsiveVideoWrapper>
      <Label>{data.caption}</Label>
    </VideoBlock>
  )
}

export default BlockVideo
